<template>

<div class="clearfix_" id="christmasTemplate">
    <div class="christmasTemplate_footer_bg"><img src="http://img.source.9188cn.com/christmasTemplate_footer_bg.png"></div>
    <div class="banner" id="banner">
        <img class="banner_bg" src="http://img.source.9188cn.com/christmasTemplateBanner_1.png">
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='recommend_christmas'">
            <div class="" id="recommend_christmas">
                <div class="recommend_list clearfix_">
                    <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx"  class="fl recommend_item">
                        <img class="recommend_item_bg" src="http://img.source.9188cn.com/recommend_christmas1.png">
                        <img class="recommend_item_img" :src="val.pic">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="christmas_benner_doll"><img src="http://img.source.9188cn.com/christmasTemplateBannerDoll.png"></div>
    <div class="christmas_content">
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='christmas_goods1'||item.parentName=='christmas_goods1_copy1'||item.parentName=='christmas_goods1_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="christmas_goods1" id="christmas_goods1">
                <div>
                    <div class="christmas_goods1_title">{{item.title}}</div>
                    <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="christmas_goods1_goods clearfix_">
                        <div class="fl christmas_goods1_goods_txt">
                            <div class="christmas_goods1_goods_name1">{{val.name}}</div>
                            <div class="christmas_goods1_goods_name2">{{val.goodsSellPoint}}</div>
                            <div class="christmas_goods1_goods_price">圣诞价：<span>{{val.beforePrice}}</span>{{val.afterPrice}}</div>
                            <div class="christmas_goods1_goods_btn fr"></div>
                        </div>
                        <div class="fl christmas_goods1_goods_img"><img :src="val.pic?val.pic:noImg"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='christmas_goods2'||item.parentName=='christmas_goods2_copy1'||item.parentName=='christmas_goods2_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="christmas_goods1 christmas_goods2" id="christmas_goods2">
                <div>
                    <div class="christmas_goods1_title christmas_goods2_title">{{item.title}}</div>
                    <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="christmas_goods1_goods clearfix_">
                        <div class="fl christmas_goods1_goods_img christmas_goods2_goods_img"><img :src="val.pic?val.pic:noImg"></div>
                        <div class="fl christmas_goods1_goods_txt christmas_goods2_goods_txt">
                            <div class="christmas_goods1_goods_name1">{{val.name}}</div>
                            <div class="christmas_goods1_goods_name2">{{val.goodsSellPoint}}</div>
                            <div class="christmas_goods1_goods_price">圣诞价：<span>{{val.beforePrice}}</span>{{val.afterPrice}}</div>
                            <div class="christmas_goods1_goods_btn fr"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='christmas_goods3'||item.parentName=='christmas_goods3_copy1'||item.parentName=='christmas_goods3_copy2'">
            <div class="christmas_goods3" id="christmas_goods3">
                <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0">
                    <div class="christmas_goods3_title"><div class="christmas_goods3_title_txt">{{item.title}}</div></div>
                    <div class="christmas_goods3_goods clearfix_">
                        <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="christmas_goods3_goods_item fl">
                            <div class="christmas_goods3_goods_item_img"><img :src="val.pic?val.pic:noImg"></div>
                            <div class="christmas_goods3_goods_item_name">{{val.name}}</div>
                            <div class="christmas_goods3_goods_item_box clearfix_">
                                <div class="fl christmas_goods3_goods_item_price">¥<span>{{val.beforePrice}}</span>{{val.afterPrice}}</div>
                                <div class="fl christmas_goods3_goods_item_btn">立即抢购</div>
                            </div>
                            <div class="christmas_goods3_goods_item_doll"><img src="http://img.source.9188cn.com/christmas_goods3_goods_doll.png"></div>
                            <div class="christmas_goods3_goods_item_hot"><img src="http://img.source.9188cn.com/christmas_goods3_goods_hot.png"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
    gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
    },
    goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
    },
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
        t_.allData=res.data.results
        }else{
          return this.$router.push({path: '/'})
        }
      })
    }
  }
}
</script>
<style scoped>
#christmasTemplate{
    background:#9b0010;
    padding-bottom: 450px;
    position: relative;
}
#banner{
    height: auto;
    margin-bottom: 0;
    position: relative;
}
#banner .banner_bg{
    width: 100%;
}
.christmas_benner_doll{
    width: 100%;
    margin-bottom: -120px;
}
.christmas_benner_doll img{
    width: 100%;
}
#recommend_christmas{
    width: 799px;
    height: 178px;
    position: absolute;
    bottom: 87px;
    left: 50%;
    margin-left: -394px;
}
.recommend_list{
    width: 799px;
    height: 178px;
}
.recommend_item{
    width: 253px;
    height: 178px;
    margin-right: 20px;
    position: relative;
}
.recommend_item:last-child{
    margin-right: 0;
}
.recommend_item .recommend_item_bg{
    width: 253px;
    height: 178px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 11;
}
.recommend_item .recommend_item_img{
    width: 224px;
    height: 145px;
    position: absolute;
    bottom: 6px;
    left: 5px;
    z-index: 9;
}
.christmas_content{
    background: url("http://img.source.9188cn.com/christmas_doll.png");
    background-size: 100%;
}
.christmas_goods1{
    width: 806px;
    height: 432px;
    background: url("http://img.source.9188cn.com/christmas_goods1.png");
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
}
.christmas_goods1_title{
    width: 230px;
    height: 68px;
    position: absolute;
    right: 73px;
    top: 42px;
    color: #fff;
    line-height: 68px;
    font-size: 30px;
    font-weight: 900;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.christmas_goods1_goods{
    height: 326px;
    width: 774px;
    position: absolute;
    top: 82px;
    left: 11px;
}
.christmas_goods1_goods_txt{
    width: 380px;
    padding-left: 50px;
    padding-top: 64px;
    margin-right: 50px;
}
.christmas_goods1_goods_name1{
    width: 100%;
    font-size: 36px;
    color: #d00;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 18px;
}
.christmas_goods1_goods_name2{
    width: 100%;
    font-size: 22px;
    height: 38px;
    line-height: 38px;
    color: #717171;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    border: 1px solid #5b5b5b;
    border-left: 0;
    border-right: 0;
    margin-bottom: 18px;
}
.christmas_goods1_goods_price{
    width: 100%;
    font-size: 20px;
    color: #d00;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 18px;
    font-weight: 900;
}
.christmas_goods1_goods_price span{
    font-size: 40px;
}
.christmas_goods1_goods_btn{
    width: 120px;
    height: 50px;
    background: url("http://img.source.9188cn.com/christmas_buy.png");
    background-size: 100%;
}
.christmas_goods1_goods_img{
    width: 250px;
    height: 250px;
    margin-top: 54px;
}
.christmas_goods1_goods_img img{
    width: 250px;
    height: 250px;
}
.christmas_goods2{
    background: url("http://img.source.9188cn.com/christmas_goods2.png");
}
.christmas_goods2_goods_txt{
    margin-right: 0;
    padding-left: 0;
}
.christmas_goods2_goods_img{
    margin-right: 50px;
    padding-left: 50px;
}
.christmas_goods2_title{
    left:100px;
}
.christmas_goods3{
    width: 724px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
}
.christmas_goods3_title{
    width: 377px;
    height: 145px;
    background: url("http://img.source.9188cn.com/christmas_goods3_title.png");
    background-size: 100%;
    position: relative;
    margin: 0 auto;
    margin-bottom: 30px;
}
.christmas_goods3_title_txt{
    width: 207px;
    height: 54px;
    position: absolute;
    top: 80px;
    left: 116px;
    line-height: 54px;
    text-align: center;
    font-size: 28px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.christmas_goods3_goods_item{
    position: relative;
    background: #fff;
    border-radius: 10px;
    margin-right: 34px;
    margin-bottom: 45px;
    overflow: hidden;
}
.christmas_goods3_goods_item:nth-child(2n){
    margin-right: 0;
}
.christmas_goods3_goods_item_img{
    width: 345px;
    height: 345px;
    border-radius: 10px;
}
.christmas_goods3_goods_item_img img{
    width: 345px;
    height: 345px;
}
.christmas_goods3_goods_item_name{
    font-size: 17px;
    color: #d00;
    line-height: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 340px;
    margin: 5px auto 13px auto;
}
.christmas_goods3_goods_item_price{
    width: 214px;
    height: 56px;
    line-height: 56px;
    color: #d00;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size: 24px;
    text-indent: 15px;
    font-weight: 900;
}
.christmas_goods3_goods_item_price span{
    font-size:30px;
}
.christmas_goods3_goods_item_btn{
    width: 131px;
    height: 56px;
    line-height: 56px;
    color: #fff;
    text-align: center;
    background: #d00;
    border-radius: 0 0 10px 10px;
    font-size: 22px;
}
.christmas_goods3_goods_item_doll{
    width: 345px;
    height: 30px;
    position: absolute;
    bottom: 46px;
    left: 2px;
}
.christmas_goods3_goods_item_doll img{
    width: 345px;
    height: 30px;
}
.christmas_goods3_goods_item_hot{
    width: 82px;
    height: 122px;
    position: absolute;
    top: 0px;
    left: 10px;
}
.christmas_goods3_goods_item_hot img{
    width: 82px;
    height: 122px;
}
.christmasTemplate_footer_bg{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
}
.christmasTemplate_footer_bg img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/christmasTemplate/christmasTemplate.vue